import Vue from 'vue'
import x2js from 'x2js'

Vue.prototype.$x2js = new x2js();
